// Hides these from the additional fields section of the patient chart

export enum PatientDynamicFieldType {
  FAMILY_HISTORY = "FAMILY_HISTORY",
  MEDICAL_HISTORY = "MEDICAL_HISTORY",
  ALLERGIES = "ALLERGIES",
  PRESCRIPTIONS = "PRESCRIPTIONS",
  MEDICATIONS = "MEDICATIONS",
  PATIENT_REPORTED_SYMPTOMS = "PATIENT_REPORTED_SYMPTOMS",
}
